import React, { createContext, ReactNode, useContext } from 'react';

const FormElementRegistryContext = createContext<
  (fieldName: string) => ReactNode
>(() => null);

export const FormElementRegistryProvider: React.FC<{
  renderElement: (fieldName: string) => ReactNode;
  children: ReactNode;
}> = ({ renderElement, children }) => (
  <FormElementRegistryContext.Provider value={renderElement}>
    {children}
  </FormElementRegistryContext.Provider>
);

export const useFormElementRegistry = () =>
  useContext(FormElementRegistryContext);

export default FormElementRegistryContext;
